import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { sstyled as _sstyled } from 'intergalactic/utils/lib/core/index';
import { assignProps as _assignProps4 } from 'intergalactic/core';
import { assignProps as _assignProps3 } from 'intergalactic/core';
import { assignProps as _assignProps2 } from 'intergalactic/core';
import { assignProps as _assignProps } from 'intergalactic/core';
import React from 'react';
import createComponent, { Component, sstyled, Root } from 'intergalactic/core';
import SearchM from 'intergalactic/icon/Search/m';
import CloseM from 'intergalactic/icon/Close/m';
import Input from 'intergalactic/input';
import { selectContext } from './context';
import i18nEnhance from 'intergalactic/utils/lib/enhances/i18nEnhance';
import { localizedMessages } from './translations/__intergalactic-dynamic-locales';
/*__reshadow-styles__:"./style/input-search.shadow.css"*/
var style = ( /*__reshadow_css_start__*/_sstyled.insert( /*__inner_css_start__*/".___SInputSearch_1p2d2_gg_._size_m_1p2d2_gg_{height:32px}.___SSearchClear_1p2d2_gg_.__hide_1p2d2_gg_{visibility:hidden}.___SOutline_1p2d2_gg_{top:-1px;left:-1px;width:100%;border-radius:var(--intergalactic-control-rounded, 6px) var(--intergalactic-control-rounded, 6px)0 0;box-sizing:content-box}" /*__inner_css_end__*/, "1p2d2_gg_") /*__reshadow_css_end__*/, {
  "__SInputSearch": "___SInputSearch_1p2d2_gg_",
  "_size_m": "_size_m_1p2d2_gg_",
  "__SSearchClear": "___SSearchClear_1p2d2_gg_",
  "_hide": "__hide_1p2d2_gg_",
  "__SOutline": "___SOutline_1p2d2_gg_"
});
var InputSearchRoot = /*#__PURE__*/function (_Component) {
  _inherits(InputSearchRoot, _Component);
  var _super = _createSuper(InputSearchRoot);
  function InputSearchRoot() {
    var _this;
    _classCallCheck(this, InputSearchRoot);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "inputRef", /*#__PURE__*/React.createRef());
    _defineProperty(_assertThisInitialized(_this), "closeIconRef", /*#__PURE__*/React.createRef());
    _defineProperty(_assertThisInitialized(_this), "handleClear", function (e) {
      _this.handlers.value('', e);
      setTimeout(function () {
        if (document.activeElement === document.body || document.activeElement === _this.closeIconRef.current) {
          var _this$inputRef$curren;
          (_this$inputRef$curren = _this.inputRef.current) === null || _this$inputRef$curren === void 0 ? void 0 : _this$inputRef$curren.focus();
        }
      }, 0);
    });
    return _this;
  }
  _createClass(InputSearchRoot, [{
    key: "uncontrolledProps",
    value: function uncontrolledProps() {
      return {
        value: null
      };
    }
  }, {
    key: "getValueProps",
    value: function getValueProps() {
      var value = this.asProps.value;
      return {
        value: value,
        onChange: this.handlers.value,
        autoFocus: true,
        ref: this.inputRef
      };
    }
  }, {
    key: "getClearProps",
    value: function getClearProps() {
      var _this$asProps = this.asProps,
        value = _this$asProps.value,
        getI18nText = _this$asProps.getI18nText;
      return {
        role: 'button',
        ref: this.closeIconRef,
        /* hide through css because the width of the input changes */
        hide: !value,
        'aria-hidden': !value,
        interactive: true,
        'aria-label': getI18nText('clearSearch'),
        onClick: this.handleClear
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _ref = this.asProps,
        _ref5;
      var Value = InputSearch.Value;
      var SInputSearch = Input;
      var _this$asProps2 = this.asProps,
        size = _this$asProps2.size,
        styles = _this$asProps2.styles,
        hasChildren = _this$asProps2.children,
        Children = _this$asProps2.Children;
      return _ref5 = sstyled(styles), /*#__PURE__*/React.createElement(SInputSearch, _ref5.cn("SInputSearch", {
        "size": size || this.context.size || 'm',
        "styles": styles
      }), hasChildren ? /*#__PURE__*/React.createElement(Children, _ref5.cn("Children", {})) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputSearch.SearchIcon, null), /*#__PURE__*/React.createElement(Value, _ref5.cn("Value", _objectSpread({}, _assignProps({}, _ref)))), /*#__PURE__*/React.createElement(InputSearch.Clear, null)));
    }
  }]);
  return InputSearchRoot;
}(Component);
_defineProperty(InputSearchRoot, "displayName", 'InputSearch');
_defineProperty(InputSearchRoot, "style", style);
_defineProperty(InputSearchRoot, "enhance", [i18nEnhance(localizedMessages)]);
_defineProperty(InputSearchRoot, "defaultProps", {
  defaultValue: '',
  i18n: localizedMessages,
  locale: 'en'
});
_defineProperty(InputSearchRoot, "contextType", selectContext);
var SearchIcon = function SearchIcon(props) {
  var _ref2 = arguments[0],
    _ref6;
  var SSearchIcon = Input.Addon;
  var styles = props.styles;
  return _ref6 = sstyled(styles), /*#__PURE__*/React.createElement(SSearchIcon, _ref6.cn("SSearchIcon", _objectSpread({}, _assignProps2({}, _ref2))), /*#__PURE__*/React.createElement(SearchM, _ref6.cn("SearchM", {})));
};
var SearchValue = function SearchValue(props) {
  var _ref3 = arguments[0],
    _ref7;
  var SSearchValue = Input.Value;
  var styles = props.styles;
  return _ref7 = sstyled(styles), /*#__PURE__*/React.createElement(SSearchValue, _ref7.cn("SSearchValue", _objectSpread({}, _assignProps3({}, _ref3))));
};
var SearchClear = function SearchClear(props) {
  var _ref4 = arguments[0],
    _ref8;
  var SSearchClear = Input.Addon;
  var styles = props.styles,
    Children = props.Children;
  return _ref8 = sstyled(styles), /*#__PURE__*/React.createElement(SSearchClear, _ref8.cn("SSearchClear", _objectSpread({}, _assignProps4({
    "tag": CloseM
  }, _ref4))), /*#__PURE__*/React.createElement(Children, _ref8.cn("Children", {})));
};
var InputSearch = createComponent(InputSearchRoot, {
  SearchIcon: SearchIcon,
  Value: SearchValue,
  Clear: SearchClear
});
export default InputSearch;
//# sourceMappingURL=InputSearch.js.map